module.exports = __webpack_public_path__ + "img/timelines_xl.2ed2100b.png";